import "@appretio/ui-kit/theme/global.css";
import { ApiClientProvider } from "@appretio/api";
import { AuthenticationProvider } from "@appretio/auth";
import { ThemeProvider } from "@appretio/ui-kit";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { RouterProvider } from "react-router-dom";
import { router } from "./routes";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      placeholderData: (prev: unknown) => prev
    }
  }
});

export function App() {
  return (
    <AuthenticationProvider>
      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools initialIsOpen={false} />
        <ApiClientProvider>
          <ThemeProvider>
            <RouterProvider router={router} />
          </ThemeProvider>
        </ApiClientProvider>
      </QueryClientProvider>
    </AuthenticationProvider>
  );
}
